/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Unavailabletitle1Inputs */

const id_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox tidak tersedia`)
};

const ms_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox tidak tersedia`)
};

const da_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox utilgængelig`)
};

const de_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox nicht verfügbar`)
};

const en_us2_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox unavailable`)
};

const es_es2_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox no disponible`)
};

const es_mx2_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox no disponible`)
};

const fil_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi available ang Sandbox`)
};

const fr_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox indisponible`)
};

const it_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox non disponibile`)
};

const hu_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox nem elérhető`)
};

const nl_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox niet beschikbaar`)
};

const no_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox utilgjengelig`)
};

const pl_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox niedostępny`)
};

const pt_br2_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox indisponível`)
};

const pt_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox indisponível`)
};

const ro_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox indisponibil`)
};

const fi_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiekkalaatikko ei käytettävissä`)
};

const sv_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandlådan inte tillgänglig`)
};

const vi_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox không khả dụng`)
};

const tr_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox kullanılamıyor`)
};

const cs_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox není k dispozici`)
};

const bg_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox не е наличен`)
};

const ru_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Песочница недоступна`)
};

const uk_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox недоступний`)
};

const ar_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox غير متاح`)
};

const hi_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सैंडबॉक्स अनुपलब्ध`)
};

const th_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แซนด์บ็อกซ์ไม่พร้อมใช้งาน`)
};

const ja_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サンドボックスは利用できません`)
};

const zh_cn2_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沙盒不可用`)
};

const zh_hant1_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沙盒無法使用`)
};

const ko_sandboxes_unavailabletitle1 = /** @type {(inputs: Sandboxes_Unavailabletitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox를 사용할 수 없음`)
};

/**
* | output |
* | --- |
* | "Sandbox unavailable" |
*
* @param {Sandboxes_Unavailabletitle1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_unavailabletitle1 = /** @type {((inputs?: Sandboxes_Unavailabletitle1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Unavailabletitle1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_unavailabletitle1(inputs)
	if (locale === "ms") return ms_sandboxes_unavailabletitle1(inputs)
	if (locale === "da") return da_sandboxes_unavailabletitle1(inputs)
	if (locale === "de") return de_sandboxes_unavailabletitle1(inputs)
	if (locale === "en-US") return en_us2_sandboxes_unavailabletitle1(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_unavailabletitle1(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_unavailabletitle1(inputs)
	if (locale === "fil") return fil_sandboxes_unavailabletitle1(inputs)
	if (locale === "fr") return fr_sandboxes_unavailabletitle1(inputs)
	if (locale === "it") return it_sandboxes_unavailabletitle1(inputs)
	if (locale === "hu") return hu_sandboxes_unavailabletitle1(inputs)
	if (locale === "nl") return nl_sandboxes_unavailabletitle1(inputs)
	if (locale === "no") return no_sandboxes_unavailabletitle1(inputs)
	if (locale === "pl") return pl_sandboxes_unavailabletitle1(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_unavailabletitle1(inputs)
	if (locale === "pt") return pt_sandboxes_unavailabletitle1(inputs)
	if (locale === "ro") return ro_sandboxes_unavailabletitle1(inputs)
	if (locale === "fi") return fi_sandboxes_unavailabletitle1(inputs)
	if (locale === "sv") return sv_sandboxes_unavailabletitle1(inputs)
	if (locale === "vi") return vi_sandboxes_unavailabletitle1(inputs)
	if (locale === "tr") return tr_sandboxes_unavailabletitle1(inputs)
	if (locale === "cs") return cs_sandboxes_unavailabletitle1(inputs)
	if (locale === "bg") return bg_sandboxes_unavailabletitle1(inputs)
	if (locale === "ru") return ru_sandboxes_unavailabletitle1(inputs)
	if (locale === "uk") return uk_sandboxes_unavailabletitle1(inputs)
	if (locale === "ar") return ar_sandboxes_unavailabletitle1(inputs)
	if (locale === "hi") return hi_sandboxes_unavailabletitle1(inputs)
	if (locale === "th") return th_sandboxes_unavailabletitle1(inputs)
	if (locale === "ja") return ja_sandboxes_unavailabletitle1(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_unavailabletitle1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_unavailabletitle1(inputs)
	return ko_sandboxes_unavailabletitle1(inputs)
});
export { sandboxes_unavailabletitle1 as "sandboxes.unavailableTitle" }